import { FunctionComponent } from 'react';
import styles from './OnlyIconButton.module.scss';
import classNames from 'classnames';

export type VisualType = 'main' | 'white' | 'blank';
export type SizeType = 'small' | 'medium' | 'large';

interface OnlyIconButtonProps {
  icon: React.ReactElement;
  className?: string;
  visualType?: VisualType;
  sizeType?: SizeType;
  onClick?(): void;
}

const OnlyIconButton: FunctionComponent<OnlyIconButtonProps> = ({
  icon,
  className,
  visualType = 'white',
  sizeType = 'medium',
  onClick,
}) => {
  return (
    <button
      className={classNames(styles['button'], styles[visualMap[visualType]], styles[sizeMap[sizeType]], className)}
      onClick={onClick}
    >
      <div className={styles['button__icon']}>{icon}</div>
    </button>
  );
};

export const visualMap: Record<VisualType, string> = {
  main: 'button--color-main',
  white: 'button--color-white',
  blank: 'button--color-blank',
};

export const sizeMap: Record<SizeType, string> = {
  small: 'main-button--size-small',
  medium: 'main-button--size-medium',
  large: 'main-button--size-large',
};

export default OnlyIconButton;
